module.exports = {
    orderManagement: {
        editDeliveryInfoPickUp: 'to collect my groceries from',
        editDeliveryInfoDelivery: 'my groceries delivered to',
        itemPickupFrom: 'Collect From:',
        itemHubSpok: 'Collect From:',
        noOrdersMessage: 'You currently have no open orders to display',
        amendingNotificationBannerTitle: 'You\'re currently changing your order',
        amendingNotificationBannerMessage: 'Please submit your changes at Checkout by {0}, or you\'ll receive your original order.',
        cutoffNotificationBannerTitle: 'You can no longer change your order',
        cutoffNotificationBannerMessage: 'Your order is currently being hand picked, packed and checked.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/order-management.js